import { useEffect, useState } from "react";
import { CONSENT_EVENT, getCookieConsent } from "./CookieBanner";

const GOOGLE_ANALYTICS_ID = "G-3P3FJPWZLC";
export const GOOGLE_ADS_ID = window.env?.REACT_APP_GOOGLE_ADS_ID;
export const GOOGLE_ADS_CONVERSION_LABEL = window.env?.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL;

export const loadGoogleTag = ({ analytics, marketing }) => {
    const shouldLoadAnalytics = analytics;
    const shouldLoadAds = marketing && GOOGLE_ADS_ID;
    if (!shouldLoadAnalytics && !shouldLoadAds) return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag("consent", "default", {
        analytics_storage: analytics ? "granted" : "denied",
        ad_storage: marketing ? "granted" : "denied",
        ad_user_data: marketing ? "granted" : "denied",
        ad_personalization: marketing ? "granted" : "denied",
    });

    if (!document.querySelector("script[data-google-tag]")) {
        const script = document.createElement("script");
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${shouldLoadAnalytics ? GOOGLE_ANALYTICS_ID : GOOGLE_ADS_ID}`;
        script.dataset.googleTag = "true";
        document.head.appendChild(script);
        window.gtag("js", new Date());
    }

    if (shouldLoadAnalytics) window.gtag("config", GOOGLE_ANALYTICS_ID);
    if (shouldLoadAds) window.gtag("config", GOOGLE_ADS_ID);
};

export default function GoogleTag() {
    const [consent, setConsent] = useState(getCookieConsent);

    useEffect(() => {
        const updateConsent = () => setConsent(getCookieConsent());
        window.addEventListener(CONSENT_EVENT, updateConsent);
        return () => window.removeEventListener(CONSENT_EVENT, updateConsent);
    }, []);

    useEffect(() => {
        loadGoogleTag(consent);
    }, [consent]);

    return null;
}